import Vue from "vue";
let _this = Vue.prototype;
export const actions = {
  actionsAddCount(context, n = 0) {
    return context.commit("mutationsAddCount", n);
  },
  actionsReduceCount({ commit }, n = 0) {
    return commit("mutationsReduceCount", n);
  },
  //获取用户信息
  actionsGetUserinfo({ commit }) {
    _this.$api.index_api.getUserInfo({}).then(res => {
      if (res&&res.code==200) return commit("mutationsGetUserinfo", res.data);
    }).catch(err => { }) ;
  },
  //获取路由
  actionsGetUserRouter({ commit }) {
    _this.$api.index_api.getRouter({}).then(res => {
      if (res) return commit("mutationsGetUserRouter", res.data);
    });
  }
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js